import { Icon } from "@/components/icons/Icon";
import { NumberInput } from "@/components/sidebar/NumberInput";
import { ActiveTooltip } from "@/components/tooltip/Tooltip";

type Props = {
  value: number | "";
  type: "width" | "height";
  label: string;
  min?: number;
  max?: number;
  placeholder?: string;
  incrementFrom?: number;
  inputClassName?: string;
  onChange: (value: number) => void;
};

export function InputSize({
  value,
  type,
  label,
  min = 1,
  max = 9999,
  placeholder,
  incrementFrom,
  inputClassName,
  onChange,
}: Props) {
  return (
    <ActiveTooltip focusDisabled title={label}>
      <NumberInput
        value={value}
        min={min}
        max={max}
        placeholder={placeholder}
        incrementFrom={incrementFrom}
        icon={<Icon name={type === "width" ? "Width" : "Height"} />}
        className="max-w-[75px]"
        inputClassName={inputClassName}
        aria-label={label}
        onSubmit={onChange}
        renderButtons={false}
      />
    </ActiveTooltip>
  );
}
